// src/pages/PaymentApproval.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export default function PaymentApproval() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pg_token = params.get("pg_token");
    const partner_order_id = params.get("partner_order_id");

    const approvePaymentRequest = async () => {
      // Check if already processing to prevent duplicate calls
      if (isProcessing) return;

      setIsProcessing(true);

      try {
        const approvePayment = httpsCallable(functions, "approvePayment");

        //console.log("21------------ 결제 승인 요청 시작:", { pg_token, partner_order_id });

        const result = await approvePayment({
          pg_token,
          partner_order_id
        });

        //console.log("22------------결제 승인 결과:", result.data);

        if (result.data.success) {
          if (result.data.is_school) {
            navigate(`/schoolPaymentSuccess?order_id=${partner_order_id}`);
          }
          else {
            navigate(`/paymentSuccess?order_id=${partner_order_id}`);
          }
        } else {
          //console.log("23------------결제 승인 실패:");
          setError("결제 승인 실패. 다시 시도해 주세요.");
        }
      } catch (err) {
        //console.log("24------------결제 승인 오류:");
        setError("결제 승인 중 오류가 발생했습니다.");
      } finally {
        //console.log("25------------결제 승인 finally:");
        setError("결제 승인 중 오류가 발생했습니다.");
        setIsProcessing(false);
      }
    };

    //console.log("26------------ pg_token:", pg_token);
    //console.log("27------------ partner_order_id:", partner_order_id);

    // TODO : check 왜 이코드가 있어서 2번씩 시도 하는지?
    if (pg_token && partner_order_id && !isProcessing) {
      approvePaymentRequest();
    } else if (!pg_token || !partner_order_id) {
      setError("필수 결제 정보가 없습니다.");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, navigate]); // Remove isProcessing from the dependency array

  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <h2 className="text-xl font-bold mb-4">오류 발생</h2>
        <p>{error}</p>
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded mt-4"
          onClick={() => navigate("/")}
        >
          홈으로 돌아가기
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 text-center">
      <h2 className="text-xl font-bold">결제 승인 중입니다...</h2>
      <p>잠시만 기다려 주세요.</p>
    </div>
  );
}